
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Size } from "../../../domain/drawing";
import { DragKinds } from "../DragKinds";

@Component({
})
export default class DragHandlesMixin extends Mixins() {
  @Prop()
  isActive: boolean;

  @Prop()
  size: Size;

  @Prop({ default: () => new Size(10, 10) })
  handleSize: Size;

  get handleWidth(): number {
    return this.handleSize.width;
  }

  get handleHeight(): number {
    return this.handleSize.height;
  }

  @Emit()
  dragHandleSelected(event: PointerEvent, kind: DragKinds): void {}
}
